const subscriptionCancelKeys = {
  "subscription.cancel.dialog.title": "Cancelar suscripción",
  "subscription.cancel.dialog.confirmation": "¿Estás seguro de que deseas cancelar tu suscripción?",
  "subscription.cancel.dialog.immediate": "Cancelar inmediatamente",
  "subscription.cancel.dialog.immediate.description": "Tu suscripción se cancelará de inmediato y perderás el acceso a todas las funciones.",
  "subscription.cancel.dialog.end-of-period":
    "Tu suscripción permanecerá activa hasta el final de tu período de facturación actual. Seguirás teniendo acceso a todas las funciones hasta entonces.",
  "subscription.cancel.dialog.active-until": "Tu suscripción estará activa hasta: {{date}}",
  "subscription.cancel.dialog.button.keep": "Mantener suscripción",
  "subscription.cancel.dialog.button.cancel": "Cancelar suscripción",
};

const subscriptionCancelSuccessDialog = {
  "subscription.cancel.notification.success.title": "Lamentamos verte partir",
  "subscription.cancel.notification.success.message": "Tu suscripción ha sido cancelada correctamente. ¡Esperamos darte la bienvenida pronto!",
  "subscription.cancel.notification.error.title": "Error al cancelar la suscripción",
  "subscription.cancel.notification.error.message": "Se produjo un error al cancelar tu suscripción. Por favor, inténtalo de nuevo.",
};

export const subscriptionCancel = {
  ...subscriptionCancelKeys,
  ...subscriptionCancelSuccessDialog,
};
